import React, { useEffect } from 'react';

import AppLoader from 'Src/components/AppLoader';
import { useLogger } from 'Src/feature/context-logger/useLogger';
import { useCurrentOperator } from 'Src/feature/operator/useCurrentOperator';
import { useOperator } from 'Src/feature/operator/useOperator';
import { useToast } from 'Src/feature/toasts/useToast';
import socket from 'Src/network/socket';
import useRoute from 'Src/routes/useRoute';

const sectionId = 'POSLogout';

/**
 * POSLogout
 * @description - route component used to log out the operator
 */
const POSLogout: React.FC = () => {
  const log = useLogger().getSubLogger({ name: sectionId });
  const toast = useToast();
  const { crumbs, navigate } = useRoute();
  const { setCurrentOperator } = useCurrentOperator();
  const operatorLogout = useOperator.mutate.logout();

  const doLogout = () => {
    operatorLogout.mutate(undefined, {
      onError: (err) => {
        log.error('doLogout', err);
        toast.show.serviceError(err, { title: 'logout' });
      },
      onSettled: (_, err) => {
        setCurrentOperator(undefined);
        if (err) socket.disconnect();
        navigate(crumbs.pos.main.path);
      },
    });
  };

  useEffect(() => {
    void doLogout();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <AppLoader />;
};

export default POSLogout;
